import { render, staticRenderFns } from "./PackagesAndComponents.vue?vue&type=template&id=7c54a6d2&scoped=true"
import script from "./PackagesAndComponents.vue?vue&type=script&lang=js"
export * from "./PackagesAndComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54a6d2",
  null
  
)

export default component.exports